export const COLOR = {
  blue : '#3498db',
  blueDark : '#2875A8',
  green: '#2ecc71',
  greenDark: '#27ae60',
  turqoise: '#1abc9c',
  turqoiseDark: '#16a085',
  white : '#ffffff',
  whiteDark: '#bdc3c7',
  defaultText : '#333333',
  grayText : '#393939',
  grayDark: '#7f8c8d',
  wetAsphalt: '#34495e',
  red: '#e74c3c',
}



// WEBPACK FOOTER //
// ./src/const/color.js